import ThemeSwitchButton from "./theme";
import { Link } from "react-router-dom";

const BlogHeader = () => {
  const header_logo = (
    <svg
      className="header-logo"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="2" y1="12" x2="22" y2="12"></line>
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
    </svg>
  );
  return (
    <div className="blog-header-wrapper">
      <div className="blog-header-inner">
        <h1><Link to={`/parry_news/`}>{header_logo} Parry News</Link></h1>
        {/* <ThemeSwitchButton /> */}
      </div>
    </div>
  );
};
export default BlogHeader;
